import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import NavigationBar from 'components/inc/NavigationBar.jsx';
import ProjectList from 'components/ProjectList/ProjectList.jsx';

import { Container } from '@material-ui/core';

class ProjectListPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }
  render() {
    return (
      <main>
        <NavigationBar />
        <Container maxWidth='lg' component='section'>
          <ProjectList />
        </Container>
      </main>
    );
  }
}

export default withStyles()(ProjectListPage);
